<div class="flex flex-col pr-2">
	<atomic-message-bar
		type="warn"
		class="mb-3"
		*ngIf="_mortgage?.lenderChanges"
		[@openClose]
	>
		<div class="flex">
			There are outstanding amendments that need to be addressed for this
			mortgage.
			<span
				class="ml-2 underline cursor-pointer text-green"
				(click)="viewAmendments()"
				>View Amendments</span
			>
		</div>
	</atomic-message-bar>

	<app-mortgage-header
		(goToInstructions)="goToLLC()"
		[details]="details"
		[mortgage]="_matterMortgage"
		(onViewAll)="viewAll()"
	>
		<button
			class="hover:underline text-green-600 gap-2 flex flex-col items-center justify-center"
			(click)="goToLLC()"
			*ngIf="_mortgage?.status !== mortgageStatuses.CANCELLED; else isCancelled"
			logo
		>
			<img src="/assets/images/integrations/llc-logo.svg" class="max-w-220" />
			<div class="flex gap-2">
				<div>Open</div>
				<app-icon [icon]="ICON.EXTERNAL"></app-icon>
			</div>
		</button>
		<ng-template #isCancelled>
			<app-pill type="remove" size="small">CANCELLED</app-pill>
		</ng-template>
	</app-mortgage-header>

	<div *ngIf="!clientsMapped" [@openClose] class="pt-10">
		<atomic-message-bar
			type="warn"
			(click)="reconcileBorrowers()"
			[clickable]="true"
		>
			<p>
				Borrower(s) not yet reconciled. Click
				<span class="bold underline">here</span> to reconcile your borrower(s)
				before proceeding to LLC.
			</p>
		</atomic-message-bar>
	</div>

	<div class="bg-white border rounded-lg">
		<app-llc-stepper
			[mortgage]="_mortgage"
			[matterMortgage]="_matterMortgage"
			class="mt-5"
		></app-llc-stepper>
	</div>

	<div class="flex flex-col mt-10">
		<atomic-button-group
			class="mb-5"
			#buttonGroup
			[options]="detailsNavOptions"
			stretchTabs="true"
			[(ngModel)]="selectedDetailNav"
		></atomic-button-group>

		<app-llc-mortgage-details
			*ngIf="selectedDetailNav === detailNavTypes.MORTGAGE_DETAILS"
			[matterMortgage]="_matterMortgage"
			[mortgage]="_mortgage"
		></app-llc-mortgage-details>
		<!-- <app-llc-lender-details *ngIf="selectedDetailNav === detailNavTypes.LENDER_DETAILS"
			[matterMortgage]="_matterMortgage" [mortgage]="_mortgage"></app-llc-lender-details> -->
		<app-matter-mortgage-payments
			[mortgage]="_matterMortgage"
			*ngIf="selectedDetailNav === detailNavTypes.PAYMENT"
		></app-matter-mortgage-payments>
		<app-mortgage-report
			*ngIf="selectedDetailNav === detailNavTypes.REPORT"
			[mortgage]="_matterMortgage"
		></app-mortgage-report>
		<app-llc-downloads-table
			*ngIf="selectedDetailNav === detailNavTypes.DOCUMENTS"
			[transactionId]="_mortgage?.id"
			[matterMortgageId]="_matterMortgage?.id"
		></app-llc-downloads-table>
	</div>
</div>
